import { useState, useRef } from 'react';
import { Card, Typography, Divider, Alert } from '@mui/material';
import DocumentUploadCardSection from './DocumentUploadCardSection';
import { HttpErrorHandler } from '../../ErrorHandler';
import API from '../../../api';

export default function EventFileCard({ event, setEvent, showSnackbar, setSnackbarText, canEdit }) {
  const [poster, setPoster] = useState(null);
  const [uploadingPoster, setUploadingPoster] = useState(false);
  const [deletingPoster, setDeletingPoster] = useState(false);
  const uploadPosterRef = useRef();

  const [program, setProgram] = useState(null);
  const [uploadingProgram, setUploadingProgram] = useState(false);
  const [deletingProgram, setDeletingProgram] = useState(false);
  const uploadProgramRef = useRef();

  const eventType = event?.type;
  // const [isPosterApiCalled, setIsPosterApiCalled] = useState(false);

  // const getPoster = () => {
  //   if (event && Object.keys(event).length > 0 && !isPosterApiCalled) {
  //     API.get(`/celebrations/${event.id}`).then((response) => {
  //       setEvent((prev) => ({
  //         ...prev,
  //         poster_url: response.data.poster_url || null,
  //       }));
  //       setIsPosterApiCalled(true);
  //     });
  //   }
  // };

  // const refreshPoster = (eventID = event.id) => {
  //   setIsPosterApiCalled(false);
  //   API.get(`/celebrations/${eventID}`).then((response) => {
  //     setEvent((prev) => ({
  //       ...prev,
  //       poster_url: response.data.poster_url || null,
  //     }));
  //     setIsPosterApiCalled(true);
  //   });
  // };

  const handlePosterUpload = async () => {
    if (!poster || !event?.id) return;
    const formData = new FormData();
    formData.append('poster', poster);
    setUploadingPoster(true);
    try {
      const url = eventType === 'celebration' ? `/celebrations/${event.id}/poster` : `/events/${event.id}/poster`;

      const res = await API.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setEvent((prev) => ({ ...prev, poster_url: res.data.url }));
      showSnackbar(true, 'Locandina caricata');
    } catch (error) {
      HttpErrorHandler(error, setSnackbarText);
      showSnackbar(false);
    } finally {
      setUploadingPoster(false);
    }
  };

  const handleDeletePoster = async () => {
    if (!event?.id || !event?.poster_url) return;

    try {
      setDeletingPoster(true);
      const url = eventType === 'celebration' ? `/celebrations/${event.id}/poster` : `/events/${event.id}/poster`;
      await API.delete(url);
      setEvent((prev) => ({ ...prev, poster_url: null }));
      setPoster(null);
      showSnackbar(true, 'Locandina eliminata');
      setDeletingPoster(false);
    } catch (error) {
      HttpErrorHandler(error, setSnackbarText);
      showSnackbar(false);
      setDeletingPoster(false);
    }
  };

  const handleProgramUpload = async () => {
    if (!program || !event?.id) return;
    const formData = new FormData();
    formData.append('program', program);
    setUploadingProgram(true);
    try {
      const url = eventType === 'celebration' ? `/celebrations/${event.id}/program` : `/events/${event.id}/program`;
      const res = await API.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setEvent((prev) => ({ ...prev, program_url: res.data.url }));
      showSnackbar(true, 'Programma caricato');
    } catch (error) {
      HttpErrorHandler(error, setSnackbarText);
      showSnackbar(false);
    } finally {
      setUploadingProgram(false);
    }
  };

  const handleDeleteProgram = async () => {
    if (!event?.id || !event?.program_url) return;

    try {
      setDeletingProgram(true);
      const url = eventType === 'celebration' ? `/celebrations/${event.id}/program` : `/events/${event.id}/program`;
      await API.delete(url);
      setEvent((prev) => ({ ...prev, program_url: null }));
      setProgram(null);
      showSnackbar(true, 'Programma eliminato');
      setDeletingProgram(false);
    } catch (error) {
      HttpErrorHandler(error, setSnackbarText);
      showSnackbar(false);
      setDeletingProgram(false);
    }
  };

  return (
    <>
      {/* <Card sx={{ p: 3, mb: 3, maxHeight: { xs: 'none', md: 300 } }}> */}
      <Card sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" sx={{ pb: 2 }}>
          Documenti Evento
        </Typography>

        {canEdit && (
          <Alert severity="error" sx={{ mb: 2 }}>
            I file caricati saranno <strong>pubblici</strong> e visibili a chiunque. <br />
            Assicurati di non caricare contenuti riservati.
          </Alert>
        )}

        <DocumentUploadCardSection
          label="Locandina"
          fileSize="10MB"
          file={poster}
          setFile={setPoster}
          uploading={uploadingPoster}
          deleting={deletingPoster}
          canEdit={canEdit}
          fileRef={uploadPosterRef}
          fileUrl={event?.poster_url}
          onUpload={handlePosterUpload}
          onDelete={handleDeletePoster}
        />

        <Divider sx={{ my: 2 }} />

        <DocumentUploadCardSection
          label="Programma"
          fileSize="10MB"
          file={program}
          setFile={setProgram}
          uploading={uploadingProgram}
          deleting={deletingProgram}
          canEdit={canEdit}
          fileRef={uploadProgramRef}
          fileUrl={event?.program_url}
          onUpload={handleProgramUpload}
          onDelete={handleDeleteProgram}
        />
      </Card>
    </>
  );
}
